(() => {
  if (window.wombatCartCouponPicker) return;
  window.wombatCartCouponPicker = true;
  const panel = document.querySelector('[data-wombat-cart-coupon]');
  const choice = panel?.querySelector('[data-coupon-choice]');
  if (!choice) return;

  const button = panel.querySelector('[data-coupon-apply]');
  const status = panel.querySelector('[data-coupon-status]');
  const root = window.Shopify?.routes?.root || '/';
  const memberCodes = ['WELCOME100-490'];
  const choices = {
    none: [],
    welcome: ['WELCOME100-490']
  };
  const normalize = (value) => String(value || '').toUpperCase();
  const isMemberCode = (value) => memberCodes.includes(normalize(value));
  const show = (message) => { status.textContent = message; };
  let busy = false;

  const readCart = async () => {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart read failed');
    return response.json();
  };
  const updateCart = async (codes) => {
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
    if (!response.ok) throw new Error('Cart update failed');
    return readCart();
  };
  const entries = (cart) => Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
  const codeList = (cart) => entries(cart).map((entry) => entry.code).filter(Boolean);
  const sameList = (left, right) => left.length === right.length &&
    left.every((code) => right.some((item) => normalize(item) === normalize(code)));
  const selectedValue = (cart) => {
    const current = codeList(cart).filter(isMemberCode).map(normalize);
    const match = Object.entries(choices).find(([key, values]) =>
      Array.from(choice.options).some((option) => option.value === key) && sameList(values, current));
    return match ? match[0] : 'none';
  };
  const choiceError = (cart, key) => {
    if (!cart.item_count) return '購物車是空的，暫時無法套用優惠。';
    if (key === 'welcome' && (cart.currency !== 'TWD' || cart.original_total_price < Number(panel.dataset.minimumCents))) {
      return '新客券須以台幣結帳，且商品金額滿 NT$490。';
    }
    return '';
  };
  const refresh = async () => {
    try {
      const cart = await readCart();
      for (const option of choice.options) {
        option.disabled = option.value === 'welcome' && !!choiceError(cart, 'welcome');
      }
      const current = selectedValue(cart);
      choice.value = Array.from(choice.options).some((option) => option.value === current && !option.disabled) ? current : 'none';
      button.disabled = cart.item_count === 0;
      const foreign = codeList(cart).filter((code) => !isMemberCode(code));
      show(current === 'none'
        ? (foreign.length ? '購物車另有優惠碼；選用會員券前會請您確認是否取代。' : '請選擇優惠券，再按「套用選擇」。')
        : '購物車目前選用的優惠已顯示；實際折扣以結帳頁為準。');
    } catch {
      button.disabled = true;
      show('暫時無法確認購物車，請重新整理後再試。');
    }
  };

  button.addEventListener('click', async () => {
    if (busy) return;
    busy = true;
    button.disabled = true;
    try {
      const cart = await readCart();
      const key = choice.value;
      const error = choiceError(cart, key);
      if (error) { show(error); return; }
      const wanted = choices[key];
      if (!wanted || !Array.from(choice.options).some((option) => option.value === key && !option.disabled)) {
        show('此帳戶沒有這張優惠券，請重新整理後再試。');
        return;
      }
      const existing = codeList(cart);
      const foreign = existing.filter((code) => !isMemberCode(code));
      if (wanted.length && foreign.length && !window.confirm('選用會員優惠券會取代購物車目前的其他優惠碼，確定繼續嗎？')) {
        show('已保留原有優惠，未更動購物車。');
        return;
      }
      const next = wanted.length ? wanted : foreign;
      if (sameList(existing, next)) {
        show('購物車已選用這組優惠，無須重複套用。');
        return;
      }
      show('正在更新優惠券…');
      const result = await updateCart(next);
      const confirmed = wanted.every((code) => entries(result).some((entry) => normalize(entry.code) === code && entry.applicable === true));
      const removed = existing.filter(isMemberCode).filter((code) => !wanted.includes(normalize(code)))
        .every((code) => !codeList(result).some((current) => normalize(current) === normalize(code)));
      if (!confirmed || !removed) {
        try { await updateCart(existing); } catch {}
        show('優惠券未確認成功；已嘗試恢復原選擇。請重新整理購物車核對，並於結帳頁確認資格。');
        return;
      }
      window.location.reload();
    } catch {
      show('優惠券更新結果未確認，請重新整理購物車再查看。');
    } finally {
      busy = false;
      button.disabled = false;
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', refresh);
  refresh();
})();

